<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        App.EDOWebEditor.OPENED_FIELD
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="onCancel()">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-20">
        <b-field
          class="min-size mx-4"
          customClass="has-text-color-7"
          :label="`${General.FIELD_NAME}:`"
        >
          <b-input
            v-model="inputName"
            :placeholder="App.EDOWebEditor.PLACEHOLDER_NAME"
          />
        </b-field>
        <b-field class="min-size mx-4" customClass="has-text-color-7">
          <template #label>
            <span>
              {{ App.MenuMain.HELP }}
            </span>
            <span class="ml-5 optional-label">
              {{ General.OPTIONAL }}
            </span>
          </template>
          <b-input
            v-model="inputPlaceholder"
            :placeholder="App.EDOWebEditor.PLACEHOLDER_HELP"
          />
        </b-field>
        <b-field
          class="min-size spacing-my-10"
          customClass="has-text-color-7"
          :label="`${General.TYPE}:`"
        >
          <section class="type-container">
            <b-field v-for="(input, index) in inputList" :key="index">
              <b-radio
                :value="selectedInput.type"
                class="has-text-color-7"
                name="selectedInput"
                :nativeValue="input.type"
                @input="selectInput(input)"
              >
                {{ input.label }}
              </b-radio>
            </b-field>
          </section>
        </b-field>
      </section>

      <footer class="modal-card-foot is-justify-content-space-between">
        <b-field class="spacing-my-20">
          <b-switch
            v-model="isMandatory"
            class="has-text-color-7"
            :trueValue="true"
            :falseValue="false"
          >
            {{ App.EDOWebEditor.MANDATORY }}
          </b-switch>
        </b-field>
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-warning'"
            outlined
            @click="() => onCancel()"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { App, General } from "@/utils/constants";

export default {
  name: "ModalAddInputDoe",

  props: {
    submit: {
      type: Function,
      required: true,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      isMandatory: false,
      inputName: "",
      inputPlaceholder: "",
      selectedInput: { label: "", type: null },
      inputSizes: {
        text: "250px",
        textarea: "400px",
        number: "100px",
        date: "250px"
      },
      inputList: [
        { label: App.EDOWebEditor.SHORT_TEXT, type: "text" },
        { label: App.EDOWebEditor.LONG_TEXT, type: "textarea" },
        { label: App.EDOWebEditor.ONLY_NUMBER, type: "number" },
        { label: App.EDOWebEditor.ONLY_DATES, type: "date" }
      ]
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },

  methods: {
    ...mapActions({
      indexerCreate: "indexerCreate",
      indexerRequest: "indexerRequest"
    }),
    inputCode(inputType) {
      const tag = inputType === "textarea" ? "textarea" : "input";
      return `<span contenteditable="false"> 
        <${tag}
          placeholder="${this.inputPlaceholder}"
          required="${this.isMandatory}"
          style="width: ${this.inputSizes[inputType]}"
          ${tag === "input" ? `type="${inputType}" />` : "></textarea>"}
      </span>`;
    },

    selectInput(input) {
      this.selectedInput = input;
    },

    confirmAction() {
      if (!this.inputName)
        this.snackToast.open({
          message: `${this.General.TYPE_NAME}.`,
          type: "is-danger",
          duration: 5000
        });
      else if (/\W/gi.test(this.inputName))
        this.snackToast.open({
          message: `${this.App.EDOWebEditor.FAIL_INPUT}.`,
          type: "is-danger",
          duration: 5000
        });
      else if (!this.selectedInput.type)
        this.snackToast.open({
          message: `${this.App.ModelsScreen.SELECT_A_TYPE}.`,
          type: "is-danger",
          duration: 5000
        });
      else {
        const newInput = {
          ...this.selectedInput,
          name: this.inputName.toUpperCase(),
          value: this.inputCode(this.selectedInput.type),
          isMandatory: this.isMandatory
        };
        this.submit(newInput);

        this.close();
      }
    },

    close() {
      this.$parent.close();
    },

    onCancel() {
      this.submit(null);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 50vw;
  min-height: 100px;
  max-height: 75vh;
  background-color: $color-1;
}

.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.min-size {
  min-width: 100px;
}

.optional-label {
  font-size: 10px;
  font-weight: 300;
  color: $color-7;
}

.type-container {
  column-count: 2;
}
</style>
